export const translationConfig = {
  common: [],
  feature: 'Feature.GameDetails'
};

export default translationConfig;
